import { render, staticRenderFns } from "./searchView.vue?vue&type=template&id=27f1ced6&scoped=true&"
import script from "./searchView.vue?vue&type=script&lang=js&"
export * from "./searchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1ced6",
  null
  
)

export default component.exports